const MENU_IDS = {
    'primary': 2,
    'footer': 3,
};

export {
    MENU_IDS,
};